import { useEffect, useState } from "react";
import ResponsiveAppBar from "../../../../layouts/navbar";
import { Footer } from "../../../../layouts/footer";
import { useAppDispatch } from "../../../../../app/redux/hooks";
import { getFaqAsync } from "../../../../../app/slices/footerSlice/footerSlice";

export const Faq = () => {
  const [faq, setFaq] = useState<any>("");
  const [expandedQuestion, setExpandedQuestion] = useState<string | null>(null);
  const dispatch = useAppDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    dispatch(getFaqAsync()).then((response: any) => {
      const data = response.payload?.data;

      const groupedFaqs = data?.data?.reduce((acc: any, faq: any) => {
        if (!acc[faq.category]) {
          acc[faq.category] = [];
        }
        acc[faq.category].push({
          question: faq.question,
          answer: faq.answer,
        });
        return acc;
      }, {});
      setFaq(groupedFaqs);
    });
  }, []);

  const toggleAnswer = (questionId: string) => {
    setExpandedQuestion(expandedQuestion === questionId ? null : questionId);
  };

  return (
    <>
      <ResponsiveAppBar />
      <div
        id="wrapper"
        style={{
          fontFamily: "Albert Sans, sans-serif",
          fontSize: "14px",
          lineHeight: "22px",
          fontWeight: "400",
        }}
      >
        <h3 className="fs-22 fw-6 text-center mt-5">FAQ</h3>

        <section className="flat-spacing-9 pt-4">
          <div className="container">
            <div className="tf-accordion-wrap d-flex justify-content-between">
              <div className="box">
                <div className="tf-accordion-link-list w-100 sticky-top radius-10 border-line">
                  {Object.keys(faq).map((category, index) => (
                    <div className="tf-link-item" key={category}>
                      <a
                        className="d-flex justify-content-between align-items-center line"
                        href={`#${category}`}
                      >
                        <h6 className="fw-5">
                          {category
                            ?.toLowerCase()
                            .replace(/\b\w/g, (char: any) =>
                              char.toUpperCase()
                            )}
                        </h6>
                        <div className="icon">
                          <i className="icon-arrow1-top-left"></i>
                        </div>
                      </a>
                    </div>
                  ))}
                </div>
              </div>
              <div className="content">
                {Object.keys(faq).map((category, index) => (
                  <div key={category}>
                    <h5 id={category} className="mb_24">
                      {category
                        ?.toLowerCase()
                        .replace(/\b\w/g, (char: any) => char.toUpperCase())}
                    </h5>
                    <div className="flat-accordion style-default has-btns mb_60">
                      {faq[category]?.map((faqItem: any, index: any) => (
                        <div key={index} className="flat-toggle">
                          <div
                            className={`toggle-title ${
                              expandedQuestion === category + index
                                ? "active"
                                : ""
                            }`}
                            onClick={() => toggleAnswer(category + index)}
                          >
                            {faqItem.question}
                          </div>
                          <div
                            className="toggle-content address-text"
                            style={{
                              display:
                                expandedQuestion === category + index
                                  ? "block"
                                  : "none",
                            }}
                          >
                            <p>{faqItem.answer}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
};
